import { render, staticRenderFns } from "./Lembrar.vue?vue&type=template&id=36db1f41"
import script from "./Lembrar.vue?vue&type=script&lang=js"
export * from "./Lembrar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports